import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import products from "../data/products";
import categories from "../data/categories";
import "./CategoryPage.css";

// ─── ADD BANNER IMAGES HERE ───────────────────────────────────────────────────
// Drop your banner images in src/assets/images/ and update the imports below.
// Recommended size: 1400 × 320px (wide landscape)
import refrigeratorBanner from "../assets/images/RefrigeratorBanner.png";
import acBanner from "../assets/images/ACbanner.png";
import washingBanner from "../assets/images/washingmachinebanner.png";
import otherBanner from "../assets/images/otherAppliances.png";

const CATEGORY_BANNERS = {
  Refrigerator: refrigeratorBanner,
  "Air Conditioner": acBanner,
  "Washing Machine": washingBanner,
  "Other Appliances": otherBanner,
};

// ─── ADD CATEGORY DESCRIPTIONS HERE ──────────────────────────────────────────
const CATEGORY_DESCRIPTIONS = {
  Refrigerator:
    "Reliable refrigerator spare parts designed for everyday performance, durability, and easy replacement. From shelves and trays to covers, baskets, and stabilisers, find the right parts to keep your refrigerator working smoothly.",
  "Air Conditioner":
    "Reliable air conditioner spare parts designed for smooth cooling performance, easy replacement, and long-lasting use. From capacitors and stabilisers to stands, grills, and remotes, VICON supports your AC spare part needs with a dependable range.",
  "Washing Machine":
    "Reliable washing machine spare parts designed for smooth performance, easy replacement, and long-lasting use. From pipes and pulsators to filters, spin caps, stands, accessories, and descalers, VICON supports everyday washing machine repair and maintenance needs.",
  "Other Appliances":
    "Explore practical spare parts and accessories for microwaves, kettles, mixers, irons, water purifiers, and other home appliances. VICON offers dependable appliance part solutions for dealers, distributors, retailers, and service professionals across multiple product categories.",
};
// ─────────────────────────────────────────────────────────────────────────────

function CategoryPage() {
  const { categoryName } = useParams();
  const navigate = useNavigate();

  const subCategories = Array.from(
    new Set(
      products
        .filter((p) => p.category === categoryName)
        .map((p) => p.subCategory),
    ),
  );

  const getSubCategoryImage = (subCatName) => {
    const cat = categories.find(
      (c) => c.name.toLowerCase() === subCatName?.toLowerCase(),
    );
    return cat ? cat.image : null;
  };

  const handleSubCategoryClick = (subCategory) => {
    navigate(
      `/category/${encodeURIComponent(categoryName)}/${encodeURIComponent(subCategory)}`,
    );
  };

  const bannerSrc = CATEGORY_BANNERS[categoryName];
  const description = CATEGORY_DESCRIPTIONS[categoryName];
  const pageTitle =
    categoryName !== "Other Appliances"
      ? `${categoryName} Parts`
      : categoryName;

  return (
    <div className="category-page-bg">
      {/* ── DYNAMIC BANNER ── */}
      <div className="category-banner">
        {bannerSrc ? (
          <img
            src={bannerSrc}
            alt={categoryName}
            className="category-banner-img"
          />
        ) : (
          <div className="category-banner-fallback" />
        )}
        {/* Only show title overlay when no banner image is available */}
        {!bannerSrc && (
          <div className="category-banner-overlay">
            <h1 className="category-banner-title">{pageTitle}</h1>
          </div>
        )}
      </div>

      {/* ── CATEGORY DESCRIPTION ── */}
      {description && (
        <div className="category-description">
          <p>{description}</p>
        </div>
      )}

      {/* ── SUBCATEGORY GRID ── */}
      <div className="category-page-root">
        <div className="subcategory-grid">
          {subCategories.map((subCat) => (
            <div
              key={subCat}
              className="subcategory-card"
              onClick={() => handleSubCategoryClick(subCat)}
              tabIndex={0}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") &&
                handleSubCategoryClick(subCat)
              }
              role="button"
              aria-label={subCat}
            >
              <div className="subcategory-img-wrap">
                <img
                  src={getSubCategoryImage(subCat)}
                  alt={subCat}
                  className="subcategory-img"
                />
              </div>
              <div className="subcategory-name">{subCat}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoryPage;
